export interface StoredOrganization {
  name: string
  slug: string
  logoHeader: string | null
}

const STORAGE_KEY = 'jobexOrganizations'

export const getStoredOrganizations = (): StoredOrganization[] => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY)
    if (!stored) {
      return []
    }
    return JSON.parse(stored) as StoredOrganization[]
  } catch {
    return []
  }
}

export const addStoredOrganization = (
  organization: StoredOrganization
): void => {
  const organizations = getStoredOrganizations()
  const existingIndex = organizations.findIndex(
    (i) => i.slug === organization.slug
  )
  if (existingIndex >= 0) {
    organizations[existingIndex] = organization
  } else {
    organizations.push(organization)
  }
  localStorage.setItem(STORAGE_KEY, JSON.stringify(organizations))
}

export const removeStoredOrganization = (slug: string): void => {
  const organizations = getStoredOrganizations()
  const filtered = organizations.filter((i) => i.slug !== slug)
  localStorage.setItem(STORAGE_KEY, JSON.stringify(filtered))
}
